import { useGetEulaListQuery as _useGetEulaListQuery, useSignEulaMutation as _useSignEulaMutation, } from '../../generated/graphql-types';
export const useGetEulaListQuery = () => {
    const { data, error, loading, refetch } = _useGetEulaListQuery({
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.Admin_getEulaList,
        refetch,
    };
};
export const useSignEulaMutation = (emailId, onComplete, onError) => _useSignEulaMutation({
    variables: {
        emailId,
    },
    update: (cache, result) => {
        onComplete(result?.data.Admin_signEula);
    },
    onError: (error) => {
        onError(error);
    },
});
//# sourceMappingURL=eula-service.js.map